import { useCallback, useEffect, useState } from 'react';

import { scrollToMissingRequired } from '~/components/common/inquiry/drawer/util';

export type UseShowRequiredFieldErrorsState = {
  showRequiredFieldErrors: boolean;
  setShowRequiredFieldErrors: (show: boolean) => void;
};

export const useShowRequiredFieldErrors =
  (): UseShowRequiredFieldErrorsState => {
    const [showRequiredFieldErrors, internalSetShouldShowRequiredFieldErrors] =
      useState<boolean>(false);
    const [scrollToRequired, setScrollToRequired] = useState<boolean>(false);

    const setShowRequiredFieldErrors = useCallback((showErrors: boolean) => {
      internalSetShouldShowRequiredFieldErrors(showErrors);
      if (showErrors) {
        // When setting show required errors to true, we will schedule a scroll to first missing field.
        setScrollToRequired(true);
      }
    }, []);

    useEffect(() => {
      if (scrollToRequired) {
        scrollToMissingRequired();
        setScrollToRequired(false);
      }
    }, [scrollToRequired]);

    return {
      setShowRequiredFieldErrors,
      showRequiredFieldErrors,
    };
  };
